export default "__VITE_ASSET__p0Gg11OE__"